//#region src/order_print_state.ts
var OrderPrintState = /* @__PURE__ */ function(OrderPrintState) {
	OrderPrintState[OrderPrintState["NotPrinting"] = 0] = "NotPrinting";
	OrderPrintState[OrderPrintState["Printing"] = 1] = "Printing";
	OrderPrintState[OrderPrintState["PrintError"] = 2] = "PrintError";
	OrderPrintState[OrderPrintState["PrintSuccess"] = 3] = "PrintSuccess";
	return OrderPrintState;
}(OrderPrintState || {});
//#endregion
export { OrderPrintState };

//# sourceMappingURL=order_print_state.js.map